import { Autocomplete, SelectSize, IconClose } from '@ui/src';
import InfoRow from '../../common/info-row';
import useSicCodes from '../hooks/use-sic-codes';
import { SicCodesTypes } from './types';

import cn from '../styles.module.css';
import commonStyles from '../../common/styles.module.css';

const SicCodes = ({
  value,
  setValue,
  setValuesList,
  index,
  values,
  disabled,
  error,
  clearErrors,
}: SicCodesTypes) => {
  const {
    onChange,
    isLoading,
    onSearch,
    autocompleteList,
    onInfinateScroll,
    pagination,
    nextPageIsLoading,
    deleteSicCode,
    sicCodeErrorVisible,
  } = useSicCodes({
    values,
    index,
    setValue,
    setValuesList,
    value,
  });

  return (
    <InfoRow title="Sic codes" id="sicCodes" borderless lessPadding>
      <>
        <div className={cn.sicCodeRow}>
          <Autocomplete
            name={`sicCodes-${index}`}
            placeholder="Select values"
            value={value.id}
            onChange={(e) => {
              onChange(e);
              clearErrors(['sicCodes']);
            }}
            className={`${commonStyles.newApplicationAutocomplete} ${
              disabled ? commonStyles.newApplicationAutocompleteDisabled : ''
            }`}
            size={SelectSize.SMALL}
            isLoading={isLoading}
            onSearch={onSearch}
            list={autocompleteList}
            disabled={disabled}
            tabIndex={disabled ? -1 : 0}
            onInfinateScroll={onInfinateScroll}
            hasNextPage={pagination?.hasNextPage}
            nextPageIsLoading={nextPageIsLoading}
            error={error}
            valueWithDescription
            withInfiniteScroll
            borderless
            fullWidth
          />
          {!disabled && (
            <button
              type="button"
              className={cn.deleteSicCodeButton}
              onClick={() => deleteSicCode(value.id)}
              aria-label="Delete button"
              tabIndex={-1}
            >
              <IconClose width={15} height={15} />
            </button>
          )}
        </div>
        {sicCodeErrorVisible && (
          <div className={cn.sicCodesError}>Sic Codes must be unique</div>
        )}
      </>
    </InfoRow>
  );
};

export default SicCodes;
